import { createBrowserRouter, RouterProvider } from "react-router-dom";
import MFEContainer from "./containers/MFEContainer";

import { DocumentCenter } from "./views/DocumentCenter";
import { Documents } from "./views/Documents";
import { SnackbarProvider } from "./components/shared/Snackbar";

const router = createBrowserRouter([
  {
    path: "/document-center",
    element: <DocumentCenter />,
  },
  {
    path: "/documents",
    element: <Documents />,
  },
]);

function App() {
  return (
    <MFEContainer language="EN">
      <SnackbarProvider>
        <RouterProvider router={router} />
      </SnackbarProvider>
    </MFEContainer>
  );
}

export default App;
